import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './utils/directive/index.js'

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "@/assets/css/base.css";
import "@/assets/css/universal.less"

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.use(ElementUI);

import 'vant/lib/index.css';
import Collapse from 'vant/lib/collapse';
import CollapseItem from 'vant/lib/collapse-item';
import Icon from 'vant/lib/icon';
import ActionSheet from 'vant/lib/action-sheet';
import Search from 'vant/lib/search';
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Icon);
Vue.use(ActionSheet);
Vue.use(Search);


import axios from 'axios'
Vue.prototype.$axios = axios;
axios.defaults.withCredentials = true

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
